//https://www.nasdaq.com/symbol/snap/historical
import Stock from "./Stock.js";
import * as csvHelper from "jquery-csv";

class InMemoryStockData {
  constructor() {
    this.stocks = {};
  }

  loadSymbolCSV(symbol,fullname, csv) {
    let newStock = new Stock(symbol,fullname);
    let data = csvHelper.toObjects(csv);
    data.forEach(el => {
      //close: "204.0200"
      // date: "2019/08/02"
      // high: "206.4300"
      // low: "201.6300"
      // open: "205.5300"
      // volume: "40862120.0000"
      newStock.addData(el.date,el.high,el.low,el.open,el.close,el.volume);
      //console.log(JSON.stringify(el));
    });
    newStock.sort();
    this.stocks[symbol] = newStock;
  }

  getAllSymbols(){
    return Object.keys(this.stocks);
  }

  getStockData(){
    return this.stocks;
  }
}

//Singleton
const instance = new InMemoryStockData();
Object.freeze(instance);
export default instance;
